import {
  FETCH_CANCEL_REASONS,
  FETCH_CANCEL_REASONS_SUCCESS,
  FETCH_CANCEL_REASONS_FAILED,
  EDIT_CANCELLATION_REASON
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';

const defaultReasons = [
  { label: "Motorista demorou muito", value: 0 },
  { label: "Solicitei por engano", value: 1 },
  { label: "Mudança de planos", value: 2 },
  { label: "Encontrei outro transporte", value: 3 }
];

export const fetchCancelReasons = () => async (dispatch) => {
  dispatch({
    type: FETCH_CANCEL_REASONS,
    payload: null,
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const { data, error } = await supabase.from('cancel_reasons').select('*');
      if (!error && data && data.length > 0) {
        const simple = data.map(d => d.label || d.reason);
        dispatch({
          type: FETCH_CANCEL_REASONS_SUCCESS,
          payload: {
            simple: simple,
            complex: data
          }
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_CANCEL_REASONS_SUCCESS,
    payload: {
      simple: defaultReasons.map(d => d.label),
      complex: defaultReasons
    }
  });
};

export const editCancellationReason = (reasons, method) => async (dispatch) => {
  dispatch({
    type: EDIT_CANCELLATION_REASON,
    payload: method
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      await supabase.from('cancel_reasons').upsert(reasons);
    } catch (e) {}
  }
};
